import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../redux/hooks';
import { RowType } from '../../../../redux/slices/oldBuilder';
import BreakdownOrder from './BreakdownOrder';
import BreakdownOverall from './BreakdownOverall';
import ThinDivider from '../../../ThinDivider';

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  margin-left: 16px;
`;

interface IProps {
  showOverall?: boolean;
}

const BreakdownSettings = ({ showOverall = true }: IProps) => {
  const groups = useAppSelector(({ builder }) => builder.breakdown.groups);
  const segments = useAppSelector(
    ({ builder }) => builder[RowType.breakdownCohorts],
  );

  const showSettings = groups?.length > 0 || segments?.length > 0;

  if (!showSettings) {
    return null;
  }

  return (
    <Container>
      <BreakdownOrder />
      {showOverall && (
        <>
          <ThinDivider layout="vertical" size="short" />
          <BreakdownOverall />
        </>
      )}
    </Container>
  );
};

export default BreakdownSettings;
